<fieldset [formGroup]="parentFormGroup">
  <legend>
    <div>
      <span i18n>Booking Type</span>
      <div>
        <eas-editor-booking-item-inheritable-type-badge *ngIf="itemTreeBookingTypeForm.value !== null" [inheritableType]="'set'">
        </eas-editor-booking-item-inheritable-type-badge>
        <button *ngIf="isDeletable()"
          mat-icon-button
          aria-label="Delete booking type"
          i18n-aria-label
          (click)="onDelete()">
          <mat-icon inline>delete</mat-icon>
        </button>
      </div>
    </div>
  </legend>
  <p i18n>
    Please define the type of the booking you are creating.
  </p>
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label i18n>Booking type</mat-label>
      <mat-select id="booking-type" formControlName="bookingType">
        <mat-option *ngFor="let option of bookingTypeNames" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</fieldset>
